import React from 'react'
import { Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileNavLogo, MobileLink } from './NavbarStyledComponent'
import { DiCssdeck } from 'react-icons/di';
import { FaBars } from 'react-icons/fa';
import GitHubIcon from "@mui/icons-material/GitHub";
import { Bio } from '../../data/constants';
import { Close, CloseRounded, GitHub } from '@mui/icons-material';
import styled, { useTheme } from 'styled-components';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme()

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'KulsoomRasheed_Resume.pdf';
    link.download = 'KulsoomRasheed_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Nav id="nav-menu">
      <NavbarContainer>
        <NavLogo className="nav-link home"to="/">
          <a
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              marginBottom: "20;",
              cursor: "pointer",
            }}
          >
            <DiCssdeck size="3rem" /> <Span className="nav-link home"to="/">Kulsoom Rasheed</Span>
          </a>
        </NavLogo>
        <MobileIcon>
          <FaBars
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          />
        </MobileIcon>
        <NavItems>
          {/* <NavLink className="nav-link home" href="/">
            Home
          </NavLink> */}
          <NavLink className="nav-link about" href="#about">
            About
          </NavLink>
          <NavLink className="nav-link skills" href="#skills">
            Skills
          </NavLink>
          <NavLink className="nav-link projects" href="#projects">
            Projects
          </NavLink>

          <NavLink href="#education">Education</NavLink>
          <NavLink className="nav-link experience" href="#experience">
            Experience
          </NavLink>
          <NavLink className="nav-link contact" href="#contact">
            Contact
          </NavLink>
        </NavItems>

        <ButtonContainer style={{ gap: 8 }}>
          <GitHubButton href={Bio.resume} target="_blank" onClick={handleDownload}>
            Resume
          </GitHubButton>
          <GitHubButton href={Bio.github} target="_blank" style={{ gap: 5 }}>

            <GitHubIcon />
            Profile
          </GitHubButton>
        </ButtonContainer>


        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <MobileLink
              href="#about"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              About
            </MobileLink>
            <MobileLink
              href="#skills"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              Skills
            </MobileLink>
            <MobileLink
              href="#projects"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              Projects
            </MobileLink>
            <MobileLink
              href="#education"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              Education
            </MobileLink>
            <MobileLink
              href="#experiences"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              Contact
            </MobileLink>
            <GitHubButton
              style={{
                padding: "10px 16px",
                background: `${theme.primary}`,
                color: "white",
                width: "max-content",
              }}
              href={Bio.github}
              target="_blank"
            >
              Github Profile
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
}

export default Navbar